

const addIdToSelectInputElement = (idName: string, element: any) => {
    for(let i in element.getElementsByClassName('ng-input')) {
        let e = element.getElementsByClassName('ng-input')[i].firstElementChild;
        if(e) {
          e.id = idName
          break
        };
        return
    }
}



export { addIdToSelectInputElement } 


// WEBPACK FOOTER //
// ./src/app/utils/addIdToSelectInputElement.ts